import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const WarningCircleFillSmall = (props: SvgIconT.Props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 14 14"
    paths={[
      'M 7 0 C 3.15 0 0 3.15 0 7 S 3.15 14 7 14 S 14 10.85 14 7 S 10.85 0 7 0 Z M 6.541 2 H 7.458 C 7.749 2 7.979 2.249 7.954 2.539 L 7.499 8 H 6.499 L 6.044 2.539 A 0.498 0.498 0 0 1 6.54 2 Z M 7 12 C 6.429 12 6 11.571 6 11 S 6.429 10 7 10 S 8 10.429 8 11 S 7.571 12 7 12 Z',
    ]}
  />
);

export default WarningCircleFillSmall;
